import ReactDOM from 'react-dom';
import App from './app/App';
import logClient, { LogLevels } from 'c9-js-log-client';
import { AppConfigService } from './common/services/AppConfigService';
import { AppContextProvider } from './common/context/AppContextProvider';
import { BrowserRouter as Router } from 'react-router-dom';
import './assets/styles/common.css';

const context: any = window || {};
const pageType = context.location.pathname.indexOf('kvittering') !== -1 ? 'receipt' : 'app';
context.OnsaTravel = (function () {
  function boostrapApplication(boostrapElement: HTMLElement) {
    const config = AppConfigService(boostrapElement.getAttribute('data-apiawshost'));
    if (boostrapElement.getAttribute('data-basename')) {
      config.baseName = boostrapElement.getAttribute('data-basename') as string;
    }
    const c9log = logClient(config.logger, config.appName, LogLevels.debug);
    c9log.debug(`Starting up application ${c9log.appName}, basename ${config.baseName}`, 'bootstrap');

    function WrapAppWithContext() {
      return (
        <Router basename={config.baseName}>
          <AppContextProvider config={config} c9log={c9log} pageType={pageType}>
            <App config={config} c9log={c9log} pageType={pageType} />
          </AppContextProvider>
        </Router>
      );
    }

    ReactDOM.render(<WrapAppWithContext />, boostrapElement);
  }

  return boostrapApplication;
})();

window.addEventListener('load', function () {
  new context.OnsaTravel(document.getElementsByTagName('onsa-travel').item(0));
});
